import React from 'react';
import Select from 'react-select';
import { FormGroup, Label } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { array, string, func, bool } from 'prop-types';

const propTypes = {
  agencies: array.isRequired,
  onAgencyChange: func.isRequired,
  agency: string,
  className: string,
  intl: intlShape.isRequired,
  disabled: bool,
};

const defaultProps = {
  agencies: [],
};

/**
 * Flow Agencies component
 *
 * @param {Object} { agency, agencies, onAgencyChange }
 * @return {JSX.Element} Select with agencies
 */
const FlowAgencies = ({ agency, agencies, className, onAgencyChange, intl, theme, disabled }) => (
    <></>
);

FlowAgencies.propTypes = propTypes;
FlowAgencies.defaultProps = defaultProps;

export default injectIntl(FlowAgencies);
